export const linkedinposts: string[] = [
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7259238460971003904?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7252608529297981442?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7258151267380662274?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7259600599707537408?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7259834308335431680?collapsed=1"
]

export const instaurls: string[] = [
    "https://www.instagram.com/p/DCBamUFMuyZ/?utm_source=ig_embed&amp;utm_campaign=loading",
    "https://www.instagram.com/reel/DA-rJmEO4Uq/?utm_source=ig_embed&amp;utm_campaign=loading",
    "https://www.instagram.com/p/DDWn1zVNLeB/"
]